<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12 header-box" >
        <img class="logo astech-logo float-md-left" src="../../assets/astech.png" alt="Astech Logo">
        <img class="af-logo float-md-right" src="../../assets/client_logo.png" alt="">
      </div>
    </div>
    <div class="background-container">
    <div class="row md-4">
      <div class="col">
        <h1 class="welcome-title text-center">Welcome to the Dual version of eLogbook</h1>
        <h3 class="welcome-subtitle text-center">for Type Practical Training</h3>
      </div>
    </div>
    <RoleSelectModal 
      v-if="showRoleModal" 
      :roles="loginUserData.roles"
      @role-selected="selectRole" 
      @close="closeRoleModal()"
    />
    <div class="row md-4">
      <div class="col">
        <!-- <h5 class="welcome-title text-center" style="color: grey;">This app has been customised to conform with the requirements of type practical training</h5> -->
      </div>
    </div>
    <div class="login-box">
      <div class="login-header">
        <h2 id="login-title">Login</h2>
      </div>
      <div class="login-form">
        <input type="text" id="email" v-model="username" placeholder="Enter Email" />
        <input type="password" id="password" v-model="password" placeholder="Enter Password" @keyup.enter="performLogin" />
        <button @click="performLogin">Login</button>

          <!-- Forgot Password link -->
        <p class="text-center mt-2">
          <a href="#" @click.prevent="openResetPasswordModal" style="color: #007BFF;">Forgot Password?</a>
        </p>

        <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
      </div>
      </div>
      <div class="info-container">
      <div class="info-box">
        <h5 style="margin-top: 2%;"><b>For more information contact:</b></h5>
        <p style="font-size: 18px; color: grey">paul.nolan@astech.ie <br>rory.mccarthy@astech.ie <br>john.maguire@astech.ie</p>
      </div>
    </div>
</div>
<reset-password-modal v-if="showResetPasswordModal" @close="closeResetPasswordModal"/>
</div>
</template>

<script>
import axios from 'axios';
import bcrypt from 'bcryptjs';
import Localbase from 'localbase';
const db = new Localbase('appDatabase');
import ResetPasswordModal from './ResetPasswordModal.vue';
import RoleSelectModal from './RoleSelectModal.vue';

export default {
  components: {
    ResetPasswordModal,
    RoleSelectModal,
  },
  data() {
    return {
      username: '',
      password: '',
      errorMessage: '',
      showResetPasswordModal: false,
      showRoleModal: false, // Flag for showing the modal
      loginUserData: null,
    };
  },
  methods: {
  async performLogin() {
    try {
      this.errorMessage = '';
      // Send a POST request to the login API
      const response = await axios.post('/api/login', {
        email: this.username,
        password: this.password,
      });

      console.log(response.data);

      // Check if the login was successful
      if (response.data.status === true) {
        const userData = response.data;

        const rolesArr = Array.isArray(userData.roles) ? userData.roles : [];
        const selectedRole = userData.role || rolesArr[0] || null;

        this.loginUserData = userData; // so RoleSelectModal has data if needed

        if (!selectedRole) {
          this.errorMessage = 'No role available for this user.';
          return;
        }

        // If user has multiple roles and API didn’t choose one, show modal instead of guessing
        if (!userData.role && rolesArr.length > 1) {
          this.showRoleModal = true;
          return;
        }

        await this.saveUserData({ ...userData, role: selectedRole });
        this.redirectUser(selectedRole);
      }
    } catch (error) {
      console.error('Login error:', error);
      if (error.isOffline === true) {
        this.performOfflineLogin();
        return;
      }
      if (error.response?.status === 403) {
        this.errorMessage = error.response.data?.message
          || 'Your account has been made inactive by an administrator.';
        return;
      }
      if (error.response && error.response.data) {
        this.errorMessage = `An error occurred during login: ${error.response.data.message}`;
      } else {
        this.errorMessage = 'An error occurred during login.';
      }
    }
  },
  async performOfflineLogin() {
    try {
      this.errorMessage = '';

      const users = await db.collection('users').get();

      if (!users || users.length === 0) {
        this.errorMessage = 'No offline login data available. Please log in online first.';
        return;
      }

      const email = this.username.trim().toLowerCase();

      const user = users.find(u =>
        String(u.email || '').toLowerCase() === email
      );

      if (!user) {
        this.errorMessage = 'No offline user found for this email. Please log in online first.';
        return;
      }

      if (!user.hashedPassword) {
        this.errorMessage = 'Offline password data is missing. Please log in online again.';
        return;
      }

      const isMatch = await bcrypt.compare(this.password, user.hashedPassword);

      if (!isMatch) {
        this.errorMessage = 'Invalid credentials for offline login.';
        return;
      }

      const rolesArr = Array.isArray(user.roles) ? user.roles : [];
      const selectedRole = user.role || rolesArr[0] || null;

      if (!selectedRole) {
        this.errorMessage = 'No role available for this offline user.';
        return;
      }

      localStorage.setItem('role', selectedRole);
      localStorage.setItem('token', user.token || '');
      localStorage.setItem('username', user.username || user.email);
      localStorage.setItem('user_id', user.user_id);

      console.log(`Offline login successful for ${user.username}, role: ${selectedRole}`);

      this.redirectUser(selectedRole);
    } catch (error) {
      console.error('Offline login error:', error);
      this.errorMessage = 'An error occurred during offline login.';
    }
  },
  async saveUserData(userData) {
    const rolesArr = Array.isArray(userData.roles) ? userData.roles : [];
    const selectedRole = userData.role || rolesArr[0] || null;

    localStorage.setItem('role', selectedRole);
    localStorage.setItem('token', userData.token);
    localStorage.setItem('username', userData.username);
    localStorage.setItem('user_id', userData.user_id);
    try {
      // Hash the password for storage
      const hashedPassword = await bcrypt.hash(this.password, 10);

      // Check for existing user records with the same email and delete them
      const existingUsers = await db.collection('users').get();
      const duplicateUsers = existingUsers.filter(user => user.email === userData.email);

      for (const duplicateUser of duplicateUsers) {
        await db.collection('users').doc({ email: duplicateUser.email }).delete();
      }

      // Add the new user data to the cache
      await db.collection('users').add({
        email: userData.email,
        roles: rolesArr,
        role: selectedRole,
        token: userData.token,
        username: userData.username,
        user_id: userData.user_id,
        hashedPassword: hashedPassword,
      });

      console.log("User data saved to Localbase, and duplicates removed.");
    } catch (error) {
      console.error("Error saving user data to Localbase:", error);
    }
  },
  redirectUser(role) {
    if (role === 'examiner' || role === 'practical_manager') {
      this.$router.push('/products');
    } else if (role === 'project_manager') {
      this.$router.push('/projects');
    } else if (role === 'trainee') {
      this.$router.push('/trainee-home');
    } else if (role === 'instructor') {
      this.$router.push('/instructor-home');
      localStorage.setItem('isAssessor', false);
    } else if (role === 'assessor') {
      localStorage.setItem('isAssessor', true);
      this.$router.push('/instructor-home');
    } else if (role === 'admin') {
      this.$router.push('/view-users');
    } else {
      console.error('Unknown user role:', role);
    }
  },
  openResetPasswordModal() {
    this.showResetPasswordModal = true;
  },
  closeResetPasswordModal() {
    this.showResetPasswordModal = false;
  },
  async selectRole(role) {
    this.showRoleModal = false; // Close the modal
    localStorage.setItem('role', role); // <-- Store selected role
    // Override the role inside the stored login data
    if (this.loginUserData) {
      this.loginUserData.role = role;
    }
    await this.saveUserData(this.loginUserData);
    this.redirectUser(role);
  },
  closeRoleModal() {
    this.showRoleModal = false; 
  },
},
};
</script>

<style scoped>
.row {
  margin-left: 0px;
  margin-right: 0px;
}

.welcome-title {
  font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
}

.welcome-subtitle {
  margin-bottom: 10px;
  font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
  color: grey;
}

.login-box {
  background-color: #fff;
  /* Background color of the box */
  border-radius: 8px;
  border: 1px solid #d8d8d8;
  /* Rounded corners for the box */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  /* Shadow effect */
  padding: 10px;
  /* Padding inside the box */
  width: 700px;
  /* Adjust the width as needed */
  height: 350px;
  margin: 10px auto 0 auto;
  /* Center the box horizontally */
}

.logo {
  height: 80px;
  /* Adjust as necessary */
  width: 150px;
}

.login-header {
  background-color: #b3c5f7;
  text-align: left;
  height: 70px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border: 1px solid #a0accc;
  display: flex;
  /* Center horizontally */
  align-items: center;
  font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
}

.login-form input {
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 5px;
}

button {
  background: #0a407a;
  color: white;
  padding: 10px;
  width: 40%;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: 0.3s;
  margin-top: 20px;
  margin-bottom: 30px;
}

button:hover {
  background: #042344;
}

h1 {
  font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
  font-size: 50px;
  /* You can add more fallback fonts after Helvetica */
}

.error-message {
  color: #FF0000;
  font-size: 14px;
  margin-bottom: 0px;
  margin-top: 0px;
}

.astech-logo {
  margin-top: 22px;
  margin-left: 6%;
  width: 180px;
  height: 75px;
  margin-bottom: 10px;
}

.af-logo {
  margin-top: 40px;
  margin-bottom: 15px;
  max-width: 350px;
  max-height: 60px;
  margin-right: 5%;
}

.bluesky-logo {
  margin-top: 18px;
  min-width: 140px;
  max-height: 80px;
  margin-right: 5%;
}

.container {
  max-width: 100%;
  padding-left: 0px;
  padding-right: 0px;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.background-container {
  background-color: #0e82c51c; /* Adjust as needed */
  flex: 1; /* Makes it take the remaining height */
  padding: 20px;
}

.info-container {
  display: flex;
  justify-content: center; /* Horizontally centers the element */
  align-items: center;
}

.info-box {
  border: 1px solid #ccc;
  padding: 20px;
  margin-top: 30px;
  border-radius: 5px;
  margin-bottom: 10px;
  width: 700px;
  background-color: #fcfcfc;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.header-box {
    border-bottom: 1px solid #a8afbd;
    display: flex;
    justify-content: space-between;
  }

</style>